export default __webpack_public_path__ + "static/media/conexion.824d96ec.png";